import Dialog from "material-ui/Dialog";
import React from "react";
import {FlatButton} from "material-ui";
import {action, observable} from "mobx";
import StyledSelect from "../../core/components/fields/styledSelect";
import {optionsSearch} from "../../core/common/service/commonDataService";
import {PARTYROLE} from "../../party/partyDomain";
import {observer} from "mobx-react";
import {LovItem} from "../../core/metamodel/mdEntity";
import {fieldStyles} from "../../core/form/createForm";

type InvoiceTemplateBilledToDialogProps = {
  dialogOpen: boolean
  onConfirm: (billedTo: LovItem) => void
  onClose: () => void
}

@observer
export default class InvoiceTemplateBilledToDialog extends React.Component<InvoiceTemplateBilledToDialogProps, InvoiceTemplateBilledToDialogProps> {
  @observable billedTo: LovItem
  @observable confirmed: boolean

  @action confirm = () => {
    this.confirmed = true;

    if (this.billedTo != null) {
      this.props.onConfirm(this.billedTo);
    }
  }

  @action close = () => {
    this.billedTo = null;
    this.confirmed = false;
    this.props.onClose();
  }

  @action onBilledToChange = (value) => {
    this.billedTo = value;
  }

  render() {
    return <Dialog
      title="Select billed to"
      actions={[
        <FlatButton key="close" label="Close" primary onClick={this.close}/>,
        <FlatButton key="confirm" label="Confirm" primary onClick={this.confirm}/>
      ]}
      modal={true}
      open={this.props.dialogOpen}
      contentStyle={{width: '80%', maxWidth: 800}}
      bodyStyle={{overflow: 'visible'}}
    >
      <div className="fx col-xs-12">
        <StyledSelect async={true}
                      floatingLabelText="Billed To *"
                      loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.CUSTOMER_ROLE]})}
                      clearable={true}
                      onChange={this.onBilledToChange}
                      value={this.billedTo}
                      errorText={this.confirmed && this.billedTo == null && "Billed To is required"}
                      {...fieldStyles.small.styledSelect}
        />
      </div>
    </Dialog>
  }
}



// WEBPACK FOOTER //
// ./src/invoice/component/invoiceTemplateBilledToDialog.tsx